import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, GatsbyImageProps } from "gatsby-plugin-image"

const imgQuery = graphql`
  {
    image: file(relativePath: { eq: "GridWithTooltip/fourPercent.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
  }
`

export default function ImageFourPercent(props: Omit<GatsbyImageProps, "image">) {
  const data = useStaticQuery(imgQuery)

  return <GatsbyImage {...props} image={getImage(data.image)!} />
}
